export default __webpack_public_path__ + "atomic/_patterns/02-molecules/leadership-card/_leadership-card.twig";